import React, { Suspense } from 'react'

import { Route, Switch } from 'react-router-dom'

import { LayoutSplashScreen } from '_metronic'

import { CONSULTAS_KARDEX, CONSULTAS_CONSUMOS, CONSULTAS_ENTRADASSALIDAS } from 'constants/codigosTransacciones'

import ConsumosPage from './consumos'
import KardexPage from './kardex'
import EntradasSalidasPage from './entradasSalidas'

export default function ConsultasPages() {
  return (
    <Suspense fallback={<LayoutSplashScreen />}>
      <Switch>
        <Route path={`/${CONSULTAS_KARDEX}`} component={KardexPage} />
        <Route path={`/${CONSULTAS_CONSUMOS}`} component={ConsumosPage} />
        <Route path={`/${CONSULTAS_ENTRADASSALIDAS}`} component={EntradasSalidasPage} />
      </Switch>
    </Suspense>
  )
}
